/* One observer, one short reveal. No scroll handlers, zoom or cascade delays. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  let observer;

  function showAll() {
    observer?.disconnect();
    observer = null;
    document.querySelectorAll('.scroll-trigger, .bw-reveal').forEach(element => {
      element.classList.remove('scroll-trigger--offscreen', 'bw-reveal--offscreen');
      element.classList.add('scroll-trigger--cancel');
    });
  }

  function initialize(root = document) {
    const dawn = [...root.querySelectorAll('.scroll-trigger')];
    const branded = [...root.querySelectorAll('.bw-section .bw-section-heading, .bw-products-heading, .bw-step, .bw-support-points article')];
    branded.forEach(element => element.classList.add('bw-reveal'));
    if (motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          target.classList.remove('scroll-trigger--offscreen', 'bw-reveal--offscreen');
          observer.unobserve(target);
        });
      }, { threshold: 0, rootMargin: '0px 0px 40px 0px' });
    }
    [...dawn, ...branded].forEach(element => {
      if (observed.has(element)) return;
      observed.add(element);
      if (element.getBoundingClientRect().top < window.innerHeight + 40) {
        element.classList.add('scroll-trigger--cancel');
        return;
      }
      element.classList.add(element.classList.contains('bw-reveal') ? 'bw-reveal--offscreen' : 'scroll-trigger--offscreen');
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  motion.addEventListener('change', () => { if (motion.matches) showAll(); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
